import React from 'react';
import { Toast, Button } from 'antd-mobile';
import {post} from '../../utils/request';
import { href } from '../../utils/util';
import api from './api';
import './index.less';

class peaceSharkRecord extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            listData: [],
            pageSize: 10,
            skipCount: 0,
            count: 0
        };
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }

    // #/peaceSharkRecord?app_stoken=xxxx&hoCourseId=xxx
    componentDidMount() {
        window.didShare = this.didShare;

        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops
            },()=>{
                this.getList()
            });
        }
    }

    // 获取列表
    getList(){
        const {urlOps, pageSize, skipCount, listData} = this.state;
        post({
            url: api.pinganActivityUserPrizeList + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                skipCount: skipCount * pageSize,
                pageSize: 10,
            }
        }).then((res) => {
            if(res.result === 'success' && res.data && res.data.length > 0){
                this.setState({
                    listData: [
                        ...listData,
                        ...res.data
                    ],
                    count: res.count
                })
            }else{
                // Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取列表失败',1);
        });
    }

    appShare(param){
        clearTimeout(this.timer)
        const { urlOps } = this.state;
        let viewPort = this.viewPort();
        post({
            url: api.selectHoActivityManagementSimpleDetail + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                activityCode: param.activityCode
            }
        }).then((res) => {
            if(res.result === 'success' && res.data){
                const data = {
                    ...res.data,
                }
                if (
                    viewPort.ios ||
                    viewPort.iPhone ||
                    viewPort.iPad
                ) {
                    if(window.webkit){
                        window.webkit.messageHandlers.share.postMessage({
                            title: data.shareTitle,
                            url: `${window.location.origin}${window.location.pathname}#/peaceSharkShare`,
                            cotent: data.shareContent,
                            img: data.shareImg
                        });

                        // window.webkit.messageHandlers.didShare.postMessage(()=>{
                        //     this.finishShareTask(param.activityUserPrizeCode)
                        // });
                        this.dsq(param.activityUserPrizeCode)
                    }
                } else {
                    if(window.huilian){
                        window.huilian.shareWeixin(`${window.location.origin}${window.location.pathname}#/peaceSharkShare`, data.shareTitle, data.shareContent, data.shareImg);
                        // window.huilian.didShare(()=>{
                        //     this.finishShareTask(param.activityUserPrizeCode)
                        // });
                        this.dsq(param.activityUserPrizeCode)
                    }
                }
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取分享信息失败',1);
        });
    }

    didShare(){
       window.localStorage.setItem('shareType', '1')
    }

    dsq(activityUserPrizeCode){
        const shareType = window.localStorage.getItem('shareType')
        if(shareType){
            clearTimeout(this.timer)
            this.finishShareTask(activityUserPrizeCode)
        }else{
            this.timer = setTimeout(()=>{
                this.dsq(activityUserPrizeCode)
            },3000)
        }
    }

    finishShareTask(activityUserPrizeCode){
        const { urlOps } = this.state;
        post({
            url: api.finishShareTask + '&app_stoken=' + urlOps.app_stoken, 
            data: {
                activityUserPrizeCode
            }
        }).then((res) => {
            if(res.result === 'success'){
                Toast.info('分享成功',1);
                this.setState({
                    skipCount: 0,
                    listData: [],
                },()=>{
                    this.getList()
                })
            }else{
                Toast.info(res.msg,1);
            }
            window.localStorage.removeItem('shareType')
        }, (res)=>{
            Toast.info('调用分享结果失败',1);
        });
    }

    render() {
        const {urlOps, listData, skipCount, count} = this.state
        return (
            <div className="peaceSharkRecordBox">
                <div className="contentBox zj">
                    <div className="listBox">
                        {
                            listData.map((item,index)=>{
                                return (
                                    <div key={index}>
                                        <div className="listTitle">
                                            <div className="left">
                                                <b>{
                                                    item.prizeClassify == '0' ? item.couponsName : item.cash+'元现金'
                                                }</b>
                                            </div>
                                            <div className={item.taskStatus == '0' ? 'right_w right' : 'right'}>
                                                {['未到账','已到账'][item.taskStatus]}
                                            </div>
                                        </div>
                                        <div className="listTips">
                                            <div className="left">
                                                {item.gmtCreate}
                                            </div>
                                            {item.taskType != 0 && item.taskStatus == 0 ? (
                                                <div className="right" onClick={()=>{
                                                    if(item.taskType == '1'){
                                                        // window.location.replace(`#/safetyTrainingCoursesIndex?app_stoken=${urlOps.app_stoken}&questionBankCode=${item.questionBankCode}&activityUserPrizeCode=${item.activityUserPrizeCode}&activityCode=${item.activityCode}`);
                                                        href(`#/safetyTrainingCoursesIndex?app_stoken=${urlOps.app_stoken}&questionBankCode=${item.questionBankCode}&activityUserPrizeCode=${item.activityUserPrizeCode}&activityCode=${item.activityCode}`);
                                                    }
                                                    if(item.taskType == '2'){
                                                        this.appShare(item)
                                                    }
                                                    if(item.taskType == '3'){
                                                        let viewPort = this.viewPort();
                                                        if (
                                                            viewPort.ios ||
                                                            viewPort.iPhone ||
                                                            viewPort.iPad
                                                        ) {
                                                            if(window.webkit){
                                                                window.webkit.messageHandlers.linkCarBind.postMessage('1');
                                                            }
                                                        } else {
                                                            if(window.huilian){
                                                                window.huilian.linkCarBind();
                                                            }
                                                        }
                                                    }
                                                }}>
                                                    {['', '学习安全课程', '邀请好友', '完成车辆绑定'][item.taskType]}领{['券','现金'][item.prizeClassify]}
                                                </div>
                                            ) : ''}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        listData.length > 0 ? (
                            listData.length < count ? (
                                <div className="moreBten" onClick={()=>{
                                    this.setState({
                                        skipCount: skipCount+1
                                    },()=>{
                                        this.getList()
                                    })
                                }}>
                                    加载更多
                                </div>
                            ) : (
                                <div className="moreBten">
                                    已到底
                                </div>
                            )
                        ) : (
                            <div className="noData">
                                <div>暂无中奖记录</div>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
};

export default peaceSharkRecord;


// WEBPACK FOOTER //
// ./src/peaceSharkIndex/record/index.js